function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Screens",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Project-Tasks",
  transform: "translate(-400.000000, -292.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Task-List",
  transform: "translate(341.000000, 166.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Backlog",
  transform: "translate(30.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Task-Item",
  transform: "translate(0.000000, 60.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tick",
  transform: "translate(20.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.5611951,11.4402894 C19.976122,10.8552409 19.0250031,10.8522406 18.4369296,11.4372892 L13.4983123,16.3786994 L11.56007,14.4405385 C10.9749969,13.8554899 10.023878,13.8554899 9.43880485,14.4405385 C8.85373172,15.0255871 8.85373172,15.976666 9.43880485,16.5617146 L12.4391799,19.5619636 C12.7302163,19.8529878 13.1142643,20 13.4983123,20 C13.8823603,20 14.2664083,19.8529878 14.5604451,19.5619636 L20.5611951,13.5614655 C21.1462683,12.976417 21.1462683,12.025338 20.5611951,11.4402894 Z",
  id: "Path"
})))))));

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c308b847.svg";
export { ForwardRef as ReactComponent };